import { Flex } from "@chakra-ui/react";
import { defaultScroll } from "chakra/theme";
import { sortArrayBy } from "utils/filter-array-by";
import { ModalWhatsAppImage } from "components/chat-window/message-template/modal-image";
import MessageTemplate from "components/chat-window/message-template";
import { useChatsContext } from "../../chats-context";
import { UseWebSocketProps } from "components/atendimentos-components/use-init-web-socket/types";
import { useAttendanceContext } from "contexts/attendance-context";
import { Message } from "../hooks/use-whats-app-session-controls/types";

export function MessageList({
  wsSession,
  messages,
}: {
  wsSession: UseWebSocketProps;
  messages: Map<string, Message>;
}) {
  const { selectedAttendance } = useChatsContext();
  const { formControl } = useAttendanceContext();
  const attId = selectedAttendance?.id || formControl.values.id;
  const messagesArray = (
    sortArrayBy(Array.from(messages.values()), "timestamp", "DESC") as Message[]
  ).filter(({ attendanceId }) => attendanceId === attId);

  return (
    <Flex
      h="100%"
      sx={defaultScroll}
      overflow="auto"
      maxH={`calc(100% - 64px - 53px - 37px)`}
      flexDir="column-reverse"
      p="0px 8px 8px 8px"
    >
      {messagesArray.map((message, index) => (
        <MessageTemplate wsSession={wsSession} key={message.id} {...message} />
      ))}
      <ModalWhatsAppImage />
      {/* END CHAT */}
    </Flex>
  );
}
